"use client";

import { CheckIcon, Copy } from "lucide-react";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { toast } from "sonner";

interface CopyButtonProps {
  color?: string;
  text: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({ text, color }) => {
  const t = useTranslations(`MySimsPage.copyButton`);

  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);

      // Reset copied state after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error(t(`failed`));
      console.error("Failed to copy:", err);
    }
  };

  return (
    <button onClick={handleCopy} className={color}>
      {copied ? (
        <CheckIcon className={`h-[16px] w-[16px] ${color}`} />
      ) : (
        <Copy className={`h-[16px] w-[16px] ${color}`} />
      )}
    </button>
  );
};

export default CopyButton;
